import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

import { Eyebrow } from "@/components/landing/SiteLayout";
import { Reveal } from "@/components/landing/Reveal";
import { DecorHatch, DecorFloors } from "@/components/landing/Decor";


const STEPS = [
  { num: "01", title: "Anfrage erfassen", desc: "Kunde beschreibt Liftart, Gebäude, Standort und Projektbedarf online." },
  { num: "02", title: "Anfrage gespeichert", desc: "Die Angaben werden strukturiert im Liftblick-System erfasst." },
  { num: "03", title: "Anbieter erhalten Zugriff", desc: "Registrierte Liftanbieter sehen passende Anfragen im geschützten Portal." },
  { num: "04", title: "Direkter Kontakt", desc: "Interessierte Anbieter melden sich beim Kunden - Beratung individuell." },
];

export function SoFunktioniertSection() {
  const navigate = useNavigate();
  return (
    <>
      <section id="so-funktioniert" className="relative overflow-hidden pt-14 sm:pt-16 pb-16 sm:pb-20 bg-[#F7F8FA] scroll-mt-16">
        <DecorHatch className="left-0 top-0 h-[60%] w-[22%]" fade="right" />
        <DecorFloors className="hidden lg:block right-[5%] top-[22%] bottom-[14%] w-[96px] opacity-60" count={8} />
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="max-w-2xl mx-auto text-center mb-10 sm:mb-12">
            <Eyebrow>So funktioniert es</Eyebrow>
            <h2 className="mt-6 text-3xl sm:text-[42px] font-semibold tracking-[-0.03em] text-foreground leading-[1.1] text-balance">
              Von der Anfrage zum direkten Kontakt.
            </h2>
            <p className="mt-5 text-[15.5px] text-muted-foreground leading-[1.7]">
              Vier ruhige Schritte. Sie bleiben jederzeit Eigentümer Ihrer Anfrage und entscheiden, mit wem Sie sprechen.
            </p>
          </div>

          <ol className="flex flex-col gap-3 max-w-2xl mx-auto">
            {STEPS.map(({ num, title, desc }, i) => (
              <Reveal as="li" key={num} delay={i * 70}>
                <div className="group flex items-start gap-5 rounded-2xl bg-background px-6 py-5 sm:px-7 sm:py-6 transition-colors duration-200 hover:bg-[#EEF0F3]">
                  <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-foreground text-[11.5px] font-semibold text-background tabular-nums">
                    {num}
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-[16px] font-semibold text-foreground tracking-[-0.01em]">{title}</h3>
                    <p className="mt-1.5 text-[14px] text-muted-foreground leading-[1.65]">{desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </ol>



          <div className="mt-10 flex justify-center">
            <Button size="lg" onClick={() => navigate("/wizard")} className="h-12 px-7 rounded-sm">
              Anfrage starten
            </Button>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden py-16 sm:py-20">
        <DecorHatch className="right-0 top-0 h-full w-[28%] deco-hatch-dense opacity-70" fade="left" />
        <div className="relative max-w-2xl px-6 mx-auto">
          <Eyebrow>Transparenz</Eyebrow>
          <h2 className="mt-6 text-3xl sm:text-[40px] font-semibold tracking-[-0.03em] text-foreground leading-[1.1]">
            Kein automatischer Preisvergleich.
          </h2>
          <p className="mt-7 text-[16.5px] text-muted-foreground leading-[1.75]">
            Liftblick.ch zeigt keine pauschalen Liftpreise an, weil jedes Projekt individuell geprüft werden muss. Gebäudeart, technische Anforderungen und Ausstattung beeinflussen die Kosten. Preise und technische Details werden direkt zwischen Kunde und Anbieter besprochen.
          </p>
          <div className="mt-8">
            <Link to="/faq" className="inline-flex items-center gap-1.5 text-[14px] font-medium text-foreground hover:underline underline-offset-4">
              Häufige Fragen ansehen
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
